<div class="modal-header">
  <h4 class="modal-title" translate="{{ customerAlarmSubscription ? 'services.customerAlarm.modal.title.edit' : 'services.customerAlarm.modal.title.add' }}"></h4>

  <button class="btn-close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="alarmForm">

    <div class="row">
      <div class="col-12">
        <label class="form-label" for="iotRegister">{{ 'services.customerAlarm.modal.form.iotRegister' | translate }}*</label>
        <select class="form-control form-select" id="iotRegister" name="iotRegister"
          formControlName="iotRegister">
          @for (iotRegister of availableIotRegisters; track iotRegister) {
            <option
            [ngValue]="iotRegister">{{ getIotRegisterLabel(iotRegister) }}</option>
          }
        </select>
      </div>

      <div class="col-12">
        <label class="form-label" for="designation">{{ 'services.customerAlarm.modal.form.designation' | translate }}*</label>
        <input class="form-control" id="designation" type="text" name="designation"
          formControlName="designation" pattern="{{textInputPattern}}" maxlength="50" />
        </div>

        <div class="col-12">
          <label class="form-label">{{ 'services.customerAlarm.modal.form.active' | translate }}</label>

          <div class="form-check form-switch">
            <input class="form-check-input" id="active" type="checkbox" name="active"
              formControlName="active" />
              <label class="form-check-label" for="active">
                {{ (active.value ? 'common.state.active' : 'common.state.inactive') | translate }}
              </label>
            </div>
          </div>

          <div class="col-12">
            <label class="form-label">{{ 'services.customerAlarm.modal.form.transmissionMode' | translate }}</label>

            <div class="form-check form-switch">
              <input class="form-check-input" id="checkbox-mail" type="checkbox" name="checkbox-mail"
                formArrayName="transmissionMode"
                [formControl]="transmissionMode.get('0')"
                [value]="transmissionMode.value[0]"/>
                <label class="form-check-label" for="checkbox-mail" translate="services.customerAlarm.modal.form.transmissionModes.mail"></label>
              </div>
              <div class="form-check form-switch">
                <input class="form-check-input" id="checkbox-push" type="checkbox" name="checkbox-push"
                  formArrayName="transmissionMode"
                  [formControl]="transmissionMode.get('1')"
                  [value]="transmissionMode.value[1]"/>
                  <label class="form-check-label" for="checkbox-push" translate="services.customerAlarm.modal.form.transmissionModes.push"></label>
                </div>
              </div>

              <!-- Payment type -->
              @if (availablePaymentTypes.length > 1 && !customerAlarmSubscription) {
                <div class="col-12">
                  <label class="form-label">{{ 'common.terms.paymentType' | translate }}*</label>
                  <div>
                    <app-payment-type-chooser
                      [availablePaymentTypes]="availablePaymentTypes"
                    (selectedPaymentType)="selectPaymentType($event)"></app-payment-type-chooser>
                  </div>
                </div>
              }

              @if (!customerAlarmSubscription) {
                <app-show-cgv
                [formGroup]="alarmForm"></app-show-cgv>
              }

            </div>

          </form>
        </div>

        <div class="modal-footer">
          <button class="btn btn-outline-secondary"
            (click)="activeModal.close()"
            translate="common.cancel">
          </button>
          <button class="btn btn-primary" type="submit"
            (click)="customerAlarmSubscription ? editSubscription() : createSubscription()"
            [disabled]="alarmForm.invalid || alarmForm.pristine"
            translate="{{ customerAlarmSubscription ? 'common.modify' : 'common.subscribe' }}">
          </button>
        </div>
